var React = require('react');

function IcGlobe (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 10C20 15.52 15.52 20 10 20C4.48 20 -5.34235e-08 15.52 -1.19249e-07 10C-1.85074e-07 4.48 4.48 1.85074e-07 10 1.19249e-07C15.52 5.34235e-08 20 4.48 20 10ZM2.07 11C2.56 14.95 5.92 18 10 18C10.62 18 11.21 17.92 11.79 17.79L7 13L6 13C4.9 13 4 12.1 4 11L2.07 11ZM4.61 4.1C5.42 4.36 6 5.1 6 6L6 7L9 7C9.55 7 10 7.45 10 8L10 14L12 14L12 12C12 11.45 12.45 11 13 11L15 11L15 9C15 7.9 15.9 7 17 7L17.41 7C16.22 4.07 13.35 2 10 2C7.92 2 6.03 2.8 4.61 4.1Z","fill":"black"}));
}

IcGlobe.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcGlobe;

IcGlobe.default = IcGlobe;
